import { f } from "./lib";

export * from "./lib";
export default f;
